import React from "react";
import "./footer.css";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h1 className="footer__title">Khaled</h1>
        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">About</a>
          </li>
          <li>
            <a href="#projects" className="footer__link">Projects</a>
          </li>
          <li>
            <a href="#testimonals" className="footer__link">Testimonals</a>
          </li>
        </ul>

        <div className="footer__social">
        <a href="https://linkedin.com/in/kabdulrahmann" className="footer__social-icon" target="_blank" rel="noreferrer">
        <i class='uil uil-linkedin'></i>
        </a>
        <a href="https://github.com/kabdulrahmann" className="footer__social-icon" target="_blank" rel="noreferrer">
        <i class='uil uil-github-alt'></i>

        </a>
        <a href="https://dribble.com/kabdulrahmann" className="footer__social-icon" target="_blank" rel="noreferrer">
        <i class='bx bxl-dribbble'></i>
        </a>
        </div>
        <span className="footer__copy">&#169; Khaled. All rights reserved</span>
      </div>
    </footer>
  );
};

export default Footer;
